import React from 'react';
import { Line } from 'react-chartjs-2';

const BlockGraph = ({ data: { data, fillColour, totalTitle, currency = '' } }) => {
	let labels = data[0][1].map((labelArray) =>
		// formats dates correctly
		labelArray[0].replace(/^20([\d]{2})([\d]{2})([\d]{2})$/, '$3-$2-20$1')
	);
	const datasets = data.map((array) => ({
		label: array[0],
		fill: !!fillColour,
		cubicInterpolationMode: 'monotone',
		data: array[1].map((value) => value[1]),
		backgroundColor: fillColour || '#191919',
		pointRadius: fillColour ? 0 : 3,
		pointHitRadius: 4,
		borderColor: fillColour || '#666',
		lineTension: 0
	}));
	const totals = data.map((array) => array[1].reduce((acc, value) => acc + value[1], 0));

	let formattedData = {
		labels,
		datasets
	};

	// option documentation:
	// https://www.chartjs.org/docs/latest/charts/line.html#dataset-properties
	let options = {
		responsive: true,
		legend: {
			display: false
		},
		spanGaps: true,
		maintainAspectRatio: false,
		gridLines: {
			display: false,
			zeroLineWidth: 0
		},
		scales: {
			xAxes: [
				{
					display: false
				}
			],
			yAxes: [
				{
					gridLines: {
						drawBorder: false
					},
					ticks: {
						callback: (value) => currency + value
					}
				}
			]
		},
		tooltips: {
			callbacks: {
				label: function (tooltipItem, data) {
					let label = data.datasets[tooltipItem.datasetIndex].label || '';
					if (label) {
						label += ': ' + currency;
					}
					label += Math.round(tooltipItem.yLabel * 100) / 100;
					return label;
				}
			}
		},
		layout: {
			padding: {
				top: 10,
				bottom: 10,
				right: 10
			}
		}
	};

	return (
		<div className="linegraph-container">
			<div className={'linegraph-total-title'}>{totalTitle}</div>
			<Line data={formattedData} options={options} />
		</div>
	);
};

export default BlockGraph;
